import { render, staticRenderFns } from "./serviceIndex.vue?vue&type=template&id=bb929ca4&scoped=true"
import script from "./serviceIndex.vue?vue&type=script&lang=js"
export * from "./serviceIndex.vue?vue&type=script&lang=js"
import style0 from "./serviceIndex.vue?vue&type=style&index=0&id=bb929ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb929ca4",
  null
  
)

export default component.exports